import { atom } from 'jotai';

export const zendeskAtom = atom({ visible: false });

export default zendeskAtom;
